import { useMemo } from "react";
import * as Yup from "yup";
import { REQUIRED_MESSAGE, stringSchema } from "@/utils/form";
import { CarouselSlide } from "@/components/Common/CarouselForm/CarouselForm";
import { Formik } from "formik";
import { WalletTypeStepSlideForm } from "../WalletTypeStepSlideForm/WalletTypeStepSlideForm";
import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { AuthEventType } from "@/types/auth";
import { waitForever } from "@/utils";
import { XstateForm } from "@/components/Common/XstateForm/XstateForm";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";

export const WalletTypeStepSlide: React.FC<CarouselSlide> = ({ onPrev }) => {
  const authActorRef = AuthMachineContext.useActorRef();
  const meta = AuthMachineContext.useSelector((state) => state.context.profile?.user_metadata);
  const canGoBack = AuthMachineContext.useSelector((state) => !state.context.wantsToConnectDevice);
  const initialValues = useMemo(() => {
    return {
      walletType: meta?.wallet_type || ""
    } as WalletTypeStepFormType;
  }, [meta?.wallet_type]);

  return (
    <Formik<WalletTypeStepFormType>
      initialValues={initialValues}
      validationSchema={WalletTypeStepFormSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);

        authActorRef.send({
          type: AuthEventType.SET_WALLET_TYPE,
          value: values.walletType
        });

        trackEvent(AnalyticsEventType.WALLET_CONNECTION_INITIATED, {
          url: window.location.href,
          type: values.walletType
        });

        return waitForever();
      }}
      validateOnMount={true}
    >
      {(props) => {
        return (
          <XstateForm machineContext={AuthMachineContext}>
            <WalletTypeStepSlideForm {...props} {...(canGoBack ? { onPrev } : {})} />
          </XstateForm>
        );
      }}
    </Formik>
  );
};

export type WalletTypeStepFormType = {
  submit?: string;
  walletType: string;
};

const WalletTypeStepFormSchema = Yup.object().shape({
  walletType: stringSchema().required(REQUIRED_MESSAGE)
});
